import memoize from 'lodash/memoize';
import * as yup from 'yup';

import { convertYupErrorToMessagesObject } from '@shared/utils/validation.utils';
import { passwordSchema, confirmPasswordSchema } from '../auth.validation';

const forgotPasswordSchema = memoize(async () => yup.object().shape({
    password: await passwordSchema(),
    confirmPassword: confirmPasswordSchema,
}));

export const validateForgotPassword = async (data) => {
    const schema = await forgotPasswordSchema();

    return schema.validate(data, { convert: true, abortEarly: false }).catch(
        error => Promise.reject(convertYupErrorToMessagesObject(error)),
    );
};

export const validateConfirmPassword = (data) => {
    const getConfirmPasswordSchema = () => yup.object().shape({
        password: yup.string(),
        confirmPassword: confirmPasswordSchema,
    });

    const schema = getConfirmPasswordSchema();

    return schema.validate(data, { convert: true, abortEarly: false }).catch(
        error => Promise.reject(convertYupErrorToMessagesObject(error)),
    );
};
